import React from "react";
import dict from "../../Data/dict.json";

// Helper to extract the filename (with extension) from the URL path
const getFileName = (url) => {
  if (!url) return "";
  try {
    const decodedUrl = decodeURIComponent(url);
    return decodedUrl.split("/").pop().split("?")[0];
  } catch (error) {
    return url.split("/").pop().split("?")[0];
  }
};

// Helper to extract the name between two %% symbols AND keep the extension
const getDisplayFileName = (name) => {
  if (!name) return "";

  let extracted = name;
  const firstIndex = name.indexOf("%");
  const lastIndex = name.lastIndexOf("%");

  if (firstIndex !== -1 && lastIndex !== -1 && firstIndex !== lastIndex) {
    extracted = name.substring(firstIndex + 1, lastIndex);
    if (extracted.endsWith("_")) {
      extracted = extracted.slice(0, -1);
    }
  }

  const matchExt = name.match(/\.[0-9a-z]+$/i);
  const extension = matchExt ? matchExt[0] : "";

  if (extension && !extracted.toLowerCase().endsWith(extension.toLowerCase())) {
    extracted += extension;
  }

  return extracted;
};

export default function C_V_DOC({ value, language = "id" }) {
  const rawFileName = getFileName(value);
  const displayFileName = getDisplayFileName(rawFileName);

  return (
    <section
      style={{
        height: "100%",
        width: "100%",
        padding: "2px",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        overflow: "hidden",
      }}
    >
      {value ? (
        <span
          style={{
            fontSize: "10px",
            color: "#333",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            textAlign: "left",
          }}
          title={displayFileName}
        >
          {displayFileName}
        </span>
      ) : (
        <div
          style={{
            fontSize: "10px",
            color: "#666",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            textAlign: "left",
          }}
        >
          {dict?.["No document"]?.[language] || "No document"}
        </div>
      )}
    </section>
  );
}
